module.exports = __webpack_public_path__ + "img/img36.5a7193e2.png";